(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-features"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with the class `.NW-Explore-Trim__top`
    const trimElements = document.querySelectorAll('.NW-Advance-Features__item-heading');

    trimElements.forEach(element => {
      element.addEventListener('click', () => {
        // Toggle the `active` class on the clicked element
        element.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-slider"] && !window.DesignMode) return;
  try {
    
  function initializeBeforeAfterScroller(wrapperSelector) {
    document.querySelectorAll(wrapperSelector).forEach(function(wrapper) {
      let active = false;
      const scroller = wrapper.querySelector('.scroller');
      const beforeImage = wrapper.querySelector('.before');
      const afterImage = wrapper.querySelector('.after');
    
      // Calculate the scroller's initial position
      function calculateScrollerPosition(wrapperWidth, scrollerWidth) {
        return (wrapperWidth - scrollerWidth) / 2;
      }
    
      // Event listeners for mouse events
      scroller.addEventListener('mousedown', function() {
        active = true;
        scroller.classList.add('scrolling');
      });
    
      document.body.addEventListener('mouseup', function() {
        active = false;
        scroller.classList.remove('scrolling');
      });
    
      document.body.addEventListener('mouseleave', function() {
        active = false;
        scroller.classList.remove('scrolling');
      });
    
      document.body.addEventListener('mousemove', function(e) {
        if (!active) return;
        let x = e.pageX - wrapper.getBoundingClientRect().left;
        scrollIt(x);
      });
    
      // Event listeners for touch events
      scroller.addEventListener('touchstart', function() {
        active = true;
        scroller.classList.add('scrolling');
      });
    
      document.body.addEventListener('touchend', function() {
        active = false;
        scroller.classList.remove('scrolling');
      });
    
      document.body.addEventListener('touchcancel', function() {
        active = false;
        scroller.classList.remove('scrolling');
      });
    
      document.body.addEventListener('touchmove', function(e) {
        if (!active) return;
        let x = e.touches[0].pageX - wrapper.getBoundingClientRect().left;
        scrollIt(x);
      });
    
      function scrollIt(x) {
        let maxX = wrapper.offsetWidth;
        let scrollerWidth = scroller.offsetWidth;
    
        // Ensure the scroller is positioned correctly
        let transform = Math.max(0, Math.min(x, maxX - (scrollerWidth / 2)));
    
        // Set the after image width
        afterImage.style.width = transform + (scrollerWidth / 2) + "px";
    
        // Set the scroller position, subtracting half the scroller's width
        scroller.style.left = transform + "px";
      }
      
      // Initial setup to center the scroller
      let initialPosition = (wrapper.offsetWidth - scroller.offsetWidth) / 2;
      scrollIt(initialPosition);
    });
  }

  // Call the function to initialize scrollers
  initializeBeforeAfterScroller('.before-after-wrapper');
  
  document.addEventListener('DOMContentLoaded', function() {
      const tabs = document.querySelectorAll('[data-tab] a');
      const contents = document.querySelectorAll('[data-tab-content]');
  
      tabs.forEach(tab => {
          tab.addEventListener('click', function(event) {
              event.preventDefault();
            
              // Remove active class from all tabs
              tabs.forEach(item => item.classList.remove('active'));
              
              // Add active class to the clicked tab
              this.classList.add('active');
  
              // Get the target content ID from the href attribute
              const target = this.getAttribute('href').substring(1);
  
              // Hide all tab content
              contents.forEach(content => content.classList.remove('active'));
  
              // Show the target tab content
              document.getElementById(target).classList.add('active');

              // Call the function to initialize scrollers
              initializeBeforeAfterScroller('.before-after-wrapper');
            
          });
      });
  });

  const NWBeforeAfter = new Swiper('.NWBeforeAfter', {
    slidesPerView: 3,
    loop: true,
    spaceBetween: 23,
    allowTouchMove: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 23,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-slider"] && !window.DesignMode) return;
  try {
    
  const SwiperThumb = new Swiper('.swiper-small-thumb', {
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
      1: {
        spaceBetween: 10,
      },
      750: {
        spaceBetween: 15,
      },
      1024: {
        spaceBetween: 20,
      },
    },
  });
  const swiperMain = new Swiper('.swiper-large-thumb', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: SwiperThumb,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discover"] && !window.DesignMode) return;
  try {
    
  const NWDiscover = new Swiper('.NWDiscover', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-your-trim-pod"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with the class `.NW-Explore-Trim__top`
    const trimElements = document.querySelectorAll('.NW-Explore-Trim__top');

    trimElements.forEach(element => {
      element.addEventListener('click', () => {
        // Toggle the `active` class on the clicked element
        element.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reasons"] && !window.DesignMode) return;
  try {
    
  const NWReasonSlider = new Swiper('.NWReasonSlider', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1: {
        spaceBetween: 13,
      },
      750: {
        spaceBetween: 15,
      },
      1024: {
        spaceBetween: 30,
      },
      1200: {
        spaceBetween: 30,
      }
    },
  });
  
  // Function to destroy the swiper instance if screen width is 749px or less
  function checkAndDestroySwiper() {
    if (window.innerWidth <= 749) {
      NWReasonSlider.destroy(true, true); // Pass both parameters to completely reset and clean up events
    }
  }
  
  // Run the check on initial load
  checkAndDestroySwiper();
  
  // Add an event listener to re-check on window resize
  window.addEventListener('resize', checkAndDestroySwiper);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendation-products"] && !window.DesignMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const NWRecommendationsSlider = new Swiper('.NWRecommendationsSlider', {
    slidesPerView: 4,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1: {
        slidesPerView: 1.6,
        spaceBetween: 13,
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 25,
      },
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider-v2"] && !window.DesignMode) return;
  try {
    
    function initializeSwiper() {
        var NWReviewSliderV2 = new Swiper('.NWReviewSliderV2', {
          slidesPerView: 3,
          spaceBetween: 30,
          navigation: {
            nextEl: '.NW-Review-slider-v2__slider .swiper-button-next',
            prevEl: '.NW-Review-slider-v2__slider .swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            1: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            750: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        initializeSwiper();
    });

    document.addEventListener('shopify:section:load', function(event) {
        if (event.target.querySelector('.NWReviewSliderV2')) {
            initializeSwiper();
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !window.DesignMode) return;
  try {
    
  const NWReviewSlider = new Swiper('.NWReviewSlider', {
    slidesPerView: 4,
    spaceBetween: 27,
    navigation: {
      nextEl: '.NW-Review-slider__slider .swiper-button-next',
      prevEl: '.NW-Review-slider__slider .swiper-button-prev',
    },
    breakpoints: {
      1: {
        slidesPerView: 1.3,
        spaceBetween: 13,
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 27,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-video"] && !window.DesignMode) return;
  try {
    
  const NWTestmonialsVideo = new Swiper('.NWTestmonialsVideo', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted-by-satisfied-shavers"] && !window.DesignMode) return;
  try {
    
  const circularProgress = document.querySelectorAll(".circular-progress");

  Array.from(circularProgress).forEach((progressBar) => {
    const progressValue = progressBar.querySelector(".percentage");
    const innerCircle = progressBar.querySelector(".inner-circle");
    let startValue = 0,
      endValue = Number(progressBar.getAttribute("data-percentage")),
      speed = 50,
      progressColor = progressBar.getAttribute("data-progress-color");

    const progress = setInterval(() => {
      startValue++;
      progressValue.textContent = `${startValue}%`;
      progressValue.style.color = `${progressColor}`;

      innerCircle.style.backgroundColor = `${progressBar.getAttribute(
        "data-inner-circle-color"
      )}`;

      progressBar.style.background = `conic-gradient(${progressColor} ${
        startValue * 3.6
      }deg,${progressBar.getAttribute("data-bg-color")} 0deg)`;
      if (startValue === endValue) {
        clearInterval(progress);
      }
    }, speed);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell-collection"] && !window.DesignMode) return;
  try {
    
  const NWUpsellCollection = new Swiper(".NWUpsellCollection", {
      slidesPerView: 4,
      spaceBetween: 50,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
      1: {
        slidesPerView: 2.8,
        spaceBetween: 13,
      },
      750: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 50,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-makes-us-unique"] && !window.DesignMode) return;
  try {
    
const NWUnique = new Swiper('.NWUnique', {
  slidesPerView: 4,
  spaceBetween: 27,
  navigation: {
    nextEl: '.NW-Unique__slider .swiper-button-next',
    prevEl: '.NW-Unique__slider .swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 27,
    },
  },
});

  } catch(e) { console.error(e); }
})();
})();
